import EZO_I2C	from "../ezo_i2c.js";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "-";
    this.calibrationStatus = "-";
    
    /* publicate remote methods to clients */
    jfermi.RM_ezoec_clearCalibration = this.RM_ezoec_clearCalibration.bind(this);
    jfermi.RM_ezoec_calibrateDry = this.RM_ezoec_calibrateDry.bind(this);
    jfermi.RM_ezoec_calibrateSingle = this.RM_ezoec_calibrateSingle.bind(this);
    jfermi.RM_ezoec_calibrateLow = this.RM_ezoec_calibrateLow.bind(this);
    jfermi.RM_ezoec_calibrateHigh = this.RM_ezoec_calibrateHigh.bind(this);
    
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x64);  
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");      

      this.usbProductName = "ezo_ec";
	  this.usbSerialNumber = "0x64";    
      this.name = "ezoecSensor";
            
      this.status = "ok";
    } catch(e) {      
      this.status = "failed";
      throw e;
    }
  }
  async update(devices) {
   /* 
      from firmware version 2.13 we can use the RT command:
      RT,n set temperature compensation and take a reading

      //await this.command(`T,${devices.temperatureSensor.value?devices.temperatureSensor.value:25}`);
      //this.value = await this.command("R");
    */
    
    var T;
    if (devices.temperatureSensor)
      T = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      T = devices.ezortdSensor.value;
        
    if (true) {
      await this.command(`T,${T?T:25}`);
      this.value = parseFloat( await this.command(`R`) );   
    } else {
      this.value = parseFloat( await this.command(`RT,${T?T:25}`) );   
    }
    
    this.calibrationStatus = await this.command("Cal,?");       

  }
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");       
  }
  async calibrateDry() {
    await this.command("Cal,dry");
    this.calibrationStatus = await this.command("Cal,?");            
  }  
  async calibrateSingle(n) {
    await this.command(`Cal,${n}`);
    this.calibrationStatus = await this.command("Cal,?");              
  }
  async calibrateLow(n) {
    console.log(n);
    var result = await this.command(`Cal,low,${n}`);
    console.log(result);
    this.calibrationStatus = await this.command("Cal,?");               
  }
  async calibrateHigh(n) {
    await this.command(`Cal,high,${n}`);
    this.calibrationStatus = await this.command("Cal,?");       
  }  
  async RM_ezoec_clearCalibration(request) {
    try {
      await this.clearCalibration();
      console.log(`${request.client.username}: EZO EC Sensor calibration data has successfully been deleted`);
    } catch(e) {
      console.error(`${request.client.username}: Clear calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoec_calibrateDry(request) {
    try {
      await this.calibrateDry();
      console.log(`${request.client.username}: EZO EC Sensor dry calibration successful`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoec_calibrateSingle(request, n) {
    try {
      await this.calibrateSingle(n);
      console.log(`${request.client.username}: EZO EC Sensor singe point calibration successful`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoec_calibrateLow(request, n) {
    try {
      await this.calibrateLow(n);
      console.log(`${request.client.username}: EZO EC Sensor low point calibration successful`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoec_calibrateHigh(request, n) {
    try {
      await this.calibrateHigh(n);
      console.log(`${request.client.username}: EZO EC Sensor high point calibration successful`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,                  
      status: this.status,
      value: this.value,
      calibrationStatus: this.calibrationStatus  
    });
  }
}

export default Module;